export const moneyFormat = (price: number) => {
  const formattedPrice =
    'R$ ' +
    (+price)
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
  return formattedPrice;
};
